import React from 'react';

import { MAIL_TO } from '../config/constants';

import './styles/Footer.scss';

const Footer = () => {
    return (
        <div className="footer">
            <a href={`mailto:${MAIL_TO}`}>Envoie-nous un message</a>
        </div>
    );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.jsx